/**
 * @flow
 * @relayHash 06e01928170977062333761200827c79
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SmartCartInputQuery = {
  name?: ?string
};
export type EditSmartCartMutationVariables = {|
  input?: ?SmartCartInputQuery,
  id?: ?string,
|};
export type EditSmartCartMutationResponse = {|
  +edit_smart_cart: ?{|
    +errors: ?$ReadOnlyArray<?{|
      +code: ?number,
      +field: ?string,
      +messages: ?$ReadOnlyArray<?string>,
    |}>,
    +current_user: ?{|
      +id: string,
      +ref_id: string,
      +first_name: ?string,
      +last_name: ?string,
      +avatar: ?string,
      +email: ?string,
      +nationality: ?{|
        +ref_id: string,
        +name: ?string,
      |},
      +city: ?{|
        +ref_id: string,
        +name: ?string,
      |},
      +country: ?{|
        +ref_id: string,
        +name: ?string,
        +phone_code: ?string,
      |},
      +country_code: ?string,
      +phone_number: ?string,
      +mobile_number: ?string,
      +gender: ?string,
      +birthdate_timestamp: ?number,
      +short_address: ?string,
      +newsletter_subscription: ?boolean,
      +receive_push_notifications: ?boolean,
      +default_lang: ?string,
      +default_currency: ?string,
      +errors: ?$ReadOnlyArray<?{|
        +code: ?number,
        +field: ?string,
        +messages: ?$ReadOnlyArray<?string>,
      |}>,
      +shipping_addresses_previous: $ReadOnlyArray<?{|
        +id: string,
        +ref_id: string,
        +phone: ?string,
        +phone_code: ?string,
        +full_name: ?string,
        +firstname: ?string,
        +lastname: ?string,
        +address1: ?string,
        +lat: ?number,
        +lng: ?number,
        +inwani_building: ?number,
        +inwani_street: ?number,
        +inwani_zone: ?number,
        +country: {|
          +name: ?string,
          +ref_id: string,
          +phone_code: ?string,
          +accept_delivery_and_shipping: ?boolean,
        |},
        +state: ?{|
          +name: ?string,
          +ref_id: string,
        |},
        +save_as_default: ?boolean,
      |}>,
      +billing_addresses_previous: $ReadOnlyArray<?{|
        +id: string,
        +ref_id: string,
        +phone: ?string,
        +phone_code: ?string,
        +full_name: ?string,
        +firstname: ?string,
        +lastname: ?string,
        +address1: ?string,
        +lat: ?number,
        +lng: ?number,
        +inwani_building: ?number,
        +inwani_street: ?number,
        +inwani_zone: ?number,
        +country: {|
          +name: ?string,
          +ref_id: string,
          +phone_code: ?string,
          +accept_delivery_and_shipping: ?boolean,
        |},
        +state: ?{|
          +name: ?string,
          +ref_id: string,
        |},
        +save_as_default: ?boolean,
      |}>,
      +club: ?{|
        +id: string,
        +name: ?string,
        +ref_id: string,
      |},
      +club_attachment: ?{|
        +name: ?string
      |},
      +phone_provider: ?{|
        +id: string,
        +name: ?string,
        +ref_id: string,
      |},
      +phone_provider_attachment: ?{|
        +name: ?string
      |},
      +school: ?{|
        +id: string,
        +name: ?string,
        +ref_id: string,
      |},
      +school_attachment: ?{|
        +name: ?string
      |},
      +employer: ?{|
        +id: string,
        +name: ?string,
        +ref_id: string,
      |},
      +employer_attachment: ?{|
        +name: ?string
      |},
      +insurance_company: ?{|
        +id: string,
        +name: ?string,
        +ref_id: string,
      |},
      +insurance_company_attachment: ?{|
        +name: ?string
      |},
      +smart_carts: ?$ReadOnlyArray<?{|
        +name: ?string,
        +quantity: number,
        +id: string,
        +ref_id: string,
        +amount: number,
      |}>,
      +ayk_loyalty_program: ?{|
        +degree: ?string,
        +active_gifts_count: ?number,
        +id: string,
        +points: ?number,
        +points_to_next_gift: ?number,
        +points_to_next_level: ?number,
        +qr_code: ?{|
          +url_thumb: ?string
        |},
        +ref_id: string,
        +type: ?string,
        +vendor: ?{|
          +name: ?string,
          +logo_url: ?string,
        |},
        +silver_start_at: ?number,
        +gold_start_at: ?number,
        +diamond_start_at: ?number,
      |},
      +vendor_loyalty_programs: ?$ReadOnlyArray<?{|
        +degree: ?string,
        +active_gifts_count: ?number,
        +id: string,
        +points: ?number,
        +points_to_next_gift: ?number,
        +points_to_next_level: ?number,
        +qr_code: ?{|
          +url_thumb: ?string
        |},
        +ref_id: string,
        +type: ?string,
        +vendor: ?{|
          +name: ?string,
          +logo_url: ?string,
        |},
        +silver_start_at: ?number,
        +gold_start_at: ?number,
        +diamond_start_at: ?number,
      |}>,
      +referring_code: ?string,
    |},
  |}
|};
export type EditSmartCartMutation = {|
  variables: EditSmartCartMutationVariables,
  response: EditSmartCartMutationResponse,
|};
*/


/*
mutation EditSmartCartMutation(
  $input: SmartCartInputQuery
  $id: ID
) {
  edit_smart_cart(input: $input, id: $id) {
    errors {
      code
      field
      messages
    }
    current_user {
      id
      ref_id
      first_name
      last_name
      avatar
      email
      nationality {
        ref_id
        name
        id
      }
      city {
        ref_id
        name
        id
      }
      country {
        ref_id
        name
        phone_code
        id
      }
      country_code
      phone_number
      mobile_number
      gender
      birthdate_timestamp
      short_address
      newsletter_subscription
      receive_push_notifications
      default_lang
      default_currency
      errors {
        code
        field
        messages
      }
      shipping_addresses_previous {
        id
        ref_id
        phone
        phone_code
        full_name
        firstname
        lastname
        address1
        lat
        lng
        inwani_building
        inwani_street
        inwani_zone
        country {
          name
          ref_id
          phone_code
          accept_delivery_and_shipping
          id
        }
        state {
          name
          ref_id
          id
        }
        save_as_default
      }
      billing_addresses_previous {
        id
        ref_id
        phone
        phone_code
        full_name
        firstname
        lastname
        address1
        lat
        lng
        inwani_building
        inwani_street
        inwani_zone
        country {
          name
          ref_id
          phone_code
          accept_delivery_and_shipping
          id
        }
        state {
          name
          ref_id
          id
        }
        save_as_default
      }
      club {
        id
        name
        ref_id
      }
      club_attachment {
        name
      }
      phone_provider {
        id
        name
        ref_id
      }
      phone_provider_attachment {
        name
      }
      school {
        id
        name
        ref_id
      }
      school_attachment {
        name
      }
      employer {
        id
        name
        ref_id
      }
      employer_attachment {
        name
      }
      insurance_company {
        id
        name
        ref_id
      }
      insurance_company_attachment {
        name
      }
      smart_carts {
        name
        quantity
        id
        ref_id
        amount
      }
      ayk_loyalty_program {
        degree
        active_gifts_count
        id
        points
        points_to_next_gift
        points_to_next_level
        qr_code {
          url_thumb
        }
        ref_id
        type
        vendor {
          name
          logo_url
          id
        }
        silver_start_at
        gold_start_at
        diamond_start_at
      }
      vendor_loyalty_programs {
        degree
        active_gifts_count
        id
        points
        points_to_next_gift
        points_to_next_level
        qr_code {
          url_thumb
        }
        ref_id
        type
        vendor {
          name
          logo_url
          id
        }
        silver_start_at
        gold_start_at
        diamond_start_at
      }
      referring_code
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SmartCartInputQuery",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "SmartCartInputQuery"
  }
],
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "errors",
  "storageKey": null,
  "args": null,
  "concreteType": "Error",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "code",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "field",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "messages",
      "args": null,
      "storageKey": null
    }
  ]
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "default_currency",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "first_name",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "last_name",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "avatar",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "email",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ref_id",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v11 = [
  v9,
  v10
],
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "phone_code",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "country_code",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "phone_number",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "mobile_number",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "gender",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "birthdate_timestamp",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "short_address",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "newsletter_subscription",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "receive_push_notifications",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "default_lang",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lat",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "phone",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "full_name",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstname",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastname",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "address1",
  "args": null,
  "storageKey": null
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lng",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "inwani_building",
  "args": null,
  "storageKey": null
},
v30 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "inwani_street",
  "args": null,
  "storageKey": null
},
v31 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "inwani_zone",
  "args": null,
  "storageKey": null
},
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "accept_delivery_and_shipping",
  "args": null,
  "storageKey": null
},
v33 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "save_as_default",
  "args": null,
  "storageKey": null
},
v34 = [
  v22,
  v4,
  v23,
  v12,
  v24,
  v25,
  v26,
  v27,
  v9,
  v28,
  v29,
  v30,
  v31,
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "country",
    "storageKey": null,
    "args": null,
    "concreteType": "Country",
    "plural": false,
    "selections": [
      v10,
      v9,
      v12,
      v32
    ]
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "state",
    "storageKey": null,
    "args": null,
    "concreteType": "State",
    "plural": false,
    "selections": [
      v10,
      v9
    ]
  },
  v33
],
v35 = [
  v4,
  v10,
  v9
],
v36 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "club",
  "storageKey": null,
  "args": null,
  "concreteType": "Club",
  "plural": false,
  "selections": v35
},
v37 = [
  v10
],
v38 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "club_attachment",
  "storageKey": null,
  "args": null,
  "concreteType": "ImageDetails",
  "plural": false,
  "selections": v37
},
v39 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "phone_provider",
  "storageKey": null,
  "args": null,
  "concreteType": "PhoneProvider",
  "plural": false,
  "selections": v35
},
v40 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "phone_provider_attachment",
  "storageKey": null,
  "args": null,
  "concreteType": "ImageDetails",
  "plural": false,
  "selections": v37
},
v41 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "school",
  "storageKey": null,
  "args": null,
  "concreteType": "School",
  "plural": false,
  "selections": v35
},
v42 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "school_attachment",
  "storageKey": null,
  "args": null,
  "concreteType": "ImageDetails",
  "plural": false,
  "selections": v37
},
v43 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "employer",
  "storageKey": null,
  "args": null,
  "concreteType": "Employer",
  "plural": false,
  "selections": v35
},
v44 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "employer_attachment",
  "storageKey": null,
  "args": null,
  "concreteType": "ImageDetails",
  "plural": false,
  "selections": v37
},
v45 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "insurance_company",
  "storageKey": null,
  "args": null,
  "concreteType": "InsuranceCompany",
  "plural": false,
  "selections": v35
},
v46 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "insurance_company_attachment",
  "storageKey": null,
  "args": null,
  "concreteType": "ImageDetails",
  "plural": false,
  "selections": v37
},
v47 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "smart_carts",
  "storageKey": null,
  "args": null,
  "concreteType": "Cart",
  "plural": true,
  "selections": [
    v10,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "quantity",
      "args": null,
      "storageKey": null
    },
    v4,
    v9,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "amount",
      "args": null,
      "storageKey": null
    }
  ]
},
v48 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "qr_code",
  "storageKey": null,
  "args": null,
  "concreteType": "ImageDetails",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "url_thumb",
      "args": null,
      "storageKey": null
    }
  ]
},
v49 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "degree",
  "args": null,
  "storageKey": null
},
v50 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "points",
  "args": null,
  "storageKey": null
},
v51 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "points_to_next_gift",
  "args": null,
  "storageKey": null
},
v52 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "points_to_next_level",
  "args": null,
  "storageKey": null
},
v53 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "active_gifts_count",
  "args": null,
  "storageKey": null
},
v54 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v55 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "logo_url",
  "args": null,
  "storageKey": null
},
v56 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "silver_start_at",
  "args": null,
  "storageKey": null
},
v57 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "gold_start_at",
  "args": null,
  "storageKey": null
},
v58 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "diamond_start_at",
  "args": null,
  "storageKey": null
},
v59 = [
  v48,
  v49,
  v4,
  v50,
  v51,
  v52,
  v53,
  v9,
  v54,
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "vendor",
    "storageKey": null,
    "args": null,
    "concreteType": "Shop",
    "plural": false,
    "selections": [
      v10,
      v55
    ]
  },
  v56,
  v57,
  v58
],
v60 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "referring_code",
  "args": null,
  "storageKey": null
},
v61 = [
  v9,
  v10,
  v4
],
v62 = [
  v22,
  v4,
  v23,
  v12,
  v24,
  v25,
  v26,
  v27,
  v9,
  v28,
  v29,
  v30,
  v31,
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "country",
    "storageKey": null,
    "args": null,
    "concreteType": "Country",
    "plural": false,
    "selections": [
      v10,
      v9,
      v12,
      v32,
      v4
    ]
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "state",
    "storageKey": null,
    "args": null,
    "concreteType": "State",
    "plural": false,
    "selections": [
      v10,
      v9,
      v4
    ]
  },
  v33
],
v63 = [
  v48,
  v49,
  v4,
  v50,
  v51,
  v52,
  v53,
  v9,
  v54,
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "vendor",
    "storageKey": null,
    "args": null,
    "concreteType": "Shop",
    "plural": false,
    "selections": [
      v10,
      v55,
      v4
    ]
  },
  v56,
  v57,
  v58
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "EditSmartCartMutation",
  "id": null,
  "text": "mutation EditSmartCartMutation(\n  $input: SmartCartInputQuery\n  $id: ID\n) {\n  edit_smart_cart(input: $input, id: $id) {\n    errors {\n      code\n      field\n      messages\n    }\n    current_user {\n      id\n      ref_id\n      first_name\n      last_name\n      avatar\n      email\n      nationality {\n        ref_id\n        name\n        id\n      }\n      city {\n        ref_id\n        name\n        id\n      }\n      country {\n        ref_id\n        name\n        phone_code\n        id\n      }\n      country_code\n      phone_number\n      mobile_number\n      gender\n      birthdate_timestamp\n      short_address\n      newsletter_subscription\n      receive_push_notifications\n      default_lang\n      default_currency\n      errors {\n        code\n        field\n        messages\n      }\n      shipping_addresses_previous {\n        id\n        ref_id\n        phone\n        phone_code\n        full_name\n        firstname\n        lastname\n        address1\n        lat\n        lng\n        inwani_building\n        inwani_street\n        inwani_zone\n        country {\n          name\n          ref_id\n          phone_code\n          accept_delivery_and_shipping\n          id\n        }\n        state {\n          name\n          ref_id\n          id\n        }\n        save_as_default\n      }\n      billing_addresses_previous {\n        id\n        ref_id\n        phone\n        phone_code\n        full_name\n        firstname\n        lastname\n        address1\n        lat\n        lng\n        inwani_building\n        inwani_street\n        inwani_zone\n        country {\n          name\n          ref_id\n          phone_code\n          accept_delivery_and_shipping\n          id\n        }\n        state {\n          name\n          ref_id\n          id\n        }\n        save_as_default\n      }\n      club {\n        id\n        name\n        ref_id\n      }\n      club_attachment {\n        name\n      }\n      phone_provider {\n        id\n        name\n        ref_id\n      }\n      phone_provider_attachment {\n        name\n      }\n      school {\n        id\n        name\n        ref_id\n      }\n      school_attachment {\n        name\n      }\n      employer {\n        id\n        name\n        ref_id\n      }\n      employer_attachment {\n        name\n      }\n      insurance_company {\n        id\n        name\n        ref_id\n      }\n      insurance_company_attachment {\n        name\n      }\n      smart_carts {\n        name\n        quantity\n        id\n        ref_id\n        amount\n      }\n      ayk_loyalty_program {\n        degree\n        active_gifts_count\n        id\n        points\n        points_to_next_gift\n        points_to_next_level\n        qr_code {\n          url_thumb\n        }\n        ref_id\n        type\n        vendor {\n          name\n          logo_url\n          id\n        }\n        silver_start_at\n        gold_start_at\n        diamond_start_at\n      }\n      vendor_loyalty_programs {\n        degree\n        active_gifts_count\n        id\n        points\n        points_to_next_gift\n        points_to_next_level\n        qr_code {\n          url_thumb\n        }\n        ref_id\n        type\n        vendor {\n          name\n          logo_url\n          id\n        }\n        silver_start_at\n        gold_start_at\n        diamond_start_at\n      }\n      referring_code\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "EditSmartCartMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edit_smart_cart",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateSmartCartResult",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "current_user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              v3,
              v4,
              v5,
              v6,
              v7,
              v8,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "nationality",
                "storageKey": null,
                "args": null,
                "concreteType": "Country",
                "plural": false,
                "selections": v11
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "city",
                "storageKey": null,
                "args": null,
                "concreteType": "State",
                "plural": false,
                "selections": v11
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "country",
                "storageKey": null,
                "args": null,
                "concreteType": "Country",
                "plural": false,
                "selections": [
                  v9,
                  v10,
                  v12
                ]
              },
              v13,
              v14,
              v15,
              v16,
              v17,
              v18,
              v19,
              v20,
              v21,
              v9,
              v2,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "shipping_addresses_previous",
                "storageKey": null,
                "args": null,
                "concreteType": "Address",
                "plural": true,
                "selections": v34
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "billing_addresses_previous",
                "storageKey": null,
                "args": null,
                "concreteType": "Address",
                "plural": true,
                "selections": v34
              },
              v36,
              v38,
              v39,
              v40,
              v41,
              v42,
              v43,
              v44,
              v45,
              v46,
              v47,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "ayk_loyalty_program",
                "storageKey": null,
                "args": null,
                "concreteType": "LoyaltyProgram",
                "plural": false,
                "selections": v59
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "vendor_loyalty_programs",
                "storageKey": null,
                "args": null,
                "concreteType": "LoyaltyProgram",
                "plural": true,
                "selections": v59
              },
              v60
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "EditSmartCartMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edit_smart_cart",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateSmartCartResult",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "current_user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              v3,
              v4,
              v5,
              v6,
              v7,
              v8,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "nationality",
                "storageKey": null,
                "args": null,
                "concreteType": "Country",
                "plural": false,
                "selections": v61
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "city",
                "storageKey": null,
                "args": null,
                "concreteType": "State",
                "plural": false,
                "selections": v61
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "country",
                "storageKey": null,
                "args": null,
                "concreteType": "Country",
                "plural": false,
                "selections": [
                  v9,
                  v10,
                  v12,
                  v4
                ]
              },
              v13,
              v14,
              v15,
              v16,
              v17,
              v18,
              v19,
              v20,
              v21,
              v9,
              v2,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "shipping_addresses_previous",
                "storageKey": null,
                "args": null,
                "concreteType": "Address",
                "plural": true,
                "selections": v62
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "billing_addresses_previous",
                "storageKey": null,
                "args": null,
                "concreteType": "Address",
                "plural": true,
                "selections": v62
              },
              v36,
              v38,
              v39,
              v40,
              v41,
              v42,
              v43,
              v44,
              v45,
              v46,
              v47,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "ayk_loyalty_program",
                "storageKey": null,
                "args": null,
                "concreteType": "LoyaltyProgram",
                "plural": false,
                "selections": v63
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "vendor_loyalty_programs",
                "storageKey": null,
                "args": null,
                "concreteType": "LoyaltyProgram",
                "plural": true,
                "selections": v63
              },
              v60
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '37d87c2b4d35837500643fdaafe4bf7a';
module.exports = node;
